import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, Tag, Typography as typography_antd } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import LeaveStyle from "../../Components/LeavesStyle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import "./index.css";
import Check from "../../assets/check-svgrepo-com.svg";
import ErrorIcon from "@mui/icons-material/Error";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import env from "../../config/env";
import { useDispatch, useSelector } from "react-redux";
import { fetchRoleData } from "../../redux/slice/getRoleData";
import { fetchLeaveSummaryData } from "../../redux/slice/getLeaveSummary";
import { fetchSubLeaveTypeData } from "../../redux/slice/subLeaveType";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { CheckBox } from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import CryptoJS from "crypto-js";
import moment from "moment";

const { Title } = typography_antd;

const Allemployee = (props) => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [openModal, setopenModal] = useState(false);
  const [openFilterModal, setopenFilterModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [loading, setLoading] = useState(false);
  const [leaveSummaryData, setLeaveSummaryData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchrole, setSearchrole] = useState("");
  const [roleData, setRoleData] = useState([]);
  const [rolefilter, setRoleFilter] = useState([]);
  const [userfilter, setUserFilter] = useState([]);
  // const [userFilterName, setUserFilterName] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [userName, setUserName] = useState([]);
  const [selectedFilterCheckboxes, setSelectedFilterCheckboxes] = useState([]);
  const [selectedRoleCheckboxes, setSelectedRoleCheckboxes] = useState([]);
  const [value, setValue] = useState(0);
  const [viewUserData, setViewUserData] = useState();
  const [viewModal, setViewModal] = useState(false);
  const [tempUserFilter, setTempUserFilter] = useState([])
  const [activeStatus, setActiveStatus] = useState(true);

  const [selectedRole, setSelectedRole] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // you can change this to your preferred page size
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  // First filter by search query
  let searchFiltered = filteredData.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Then filter by selected role
  let finalFiltered = selectedRole === "All" ? searchFiltered : searchFiltered.filter((item) => item.role_value === selectedRole);

  const totalPages = Math.ceil(finalFiltered.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = finalFiltered.slice(indexOfFirstItem, indexOfLastItem);

  // // Apply search on filteredData just before paginating
  // const filteredBySearch = filteredData.filter((item) =>
  //   item.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  // const totalPages = Math.ceil(filteredBySearch.length / itemsPerPage);
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredBySearch.slice(indexOfFirstItem, indexOfLastItem);

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // set the current page value
  };

  useEffect(() => {
    setCurrentPage(1); // reset to first page when data changes
  }, [filteredData]);

  const handleActiveStatusChange = (event) => {
    const value = event.target.value;
    // If "Active" is checked, set activeStatus to true, else set it to false
    setActiveStatus(value);
  };

  useEffect(() => {
    fetchData(selectedRoleCheckboxes, selectedFilterCheckboxes, activeStatus);
  }, [activeStatus]);

  const handleStatusChange = (event) => {
    // console.log(event.target.checked,"ON CHANGEEE");
    // setActiveStatus(event.target.checked ? true : false);
    const { name } = event.target;
    setActiveStatus(name === "active"); // Set true for Active, false for Inactive
  };

  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  const state = useSelector((state) => state);
  if (state?.getLeaveSummary?.data?.status === 555 || state?.getLeaveSummary?.data?.status === 501
    || state?.getSubLeaveType?.data?.status === 555 || state?.getSubLeaveType?.data?.status === 501
    || state?.getRoleData?.data?.status === 555 || state?.getRoleData?.data?.status === 501
  ) {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    toast.error("Session expire, Please LogIn!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "1",
    });
    Navigate("/login")
  }

  const tempSubLeaveType = state?.getSubLeaveType?.data?.data;
  const tempVal = state?.getRoleData.data?.data;
  let tempLeaveSummury = state?.getLeaveSummary?.data?.data;

  useEffect(() => {
    if (token) {
      dispatch(fetchSubLeaveTypeData(token));
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      dispatch(fetchRoleData(token));
    }
  }, [token]);

  useEffect(() => {
    if (viewModal) {
      const combinedData = { viewUserData, leaveSummaryData };
      navigate('/viewemployee', { state: combinedData })
    }
  }, [viewModal])

  const handleTChange = (event, newValue) => {
    setValue(newValue);
  };

  const filterdRoles = rolefilter.length > 0 ? rolefilter : roleData?.filter((item) => item.id !== 3);

  useEffect(() => {
    if (tempVal) {
      const dataRole = tempVal?.filter((item) => item?.id !== 3);
      setRoleData(dataRole);
      fetchData(selectedRoleCheckboxes, selectedFilterCheckboxes);
    }
  }, [tempVal]);

  useEffect(() => {
    if (tempLeaveSummury && viewUserData) {
      displayData();
    }
  }, [tempLeaveSummury]);

  const fetchLeaveSummary = (row) => {
    if (row) {
      const obj = {
        id: row?.id,
        token: token
      }
      setViewUserData(row);
      dispatch(fetchLeaveSummaryData(obj));
    }
  };

  const fetchData = async (selectedRoleCheckboxes, selectedFilterCheckboxes, activeStatusClear) => {
    try {
      const encodedUsernames = selectedFilterCheckboxes.length > 0 ? encodeURIComponent(JSON.stringify(selectedFilterCheckboxes)) : "";
      const encodedRole = selectedRoleCheckboxes.length > 0 ? encodeURIComponent(JSON.stringify(selectedRoleCheckboxes)) : "";

      setLoading(false);

      const activeStatusClearFinal = activeStatusClear ? activeStatusClear : activeStatus;

      const getEmployee = CryptoJS.SHA256("/getEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encodeURIComponent(encrypt)
      }

      const encryptedName = encryptData(encodedUsernames);
      const encryptedRole = encryptData(encodedRole);
      const encryptedActiveUser = encryptData(activeStatusClearFinal);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getEmployee}?name=${encryptedName}&roleValue=${encryptedRole}&active_user=${encryptedActiveUser}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        if (errorData.status === 404) {
          setUserName([]);
          setFilteredData([]);
          setLoading(true);
        }
      }
      if (response.ok) {
        const successData = await response.json();

        if (successData.status === 200 && successData.data) {

          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          // console.log(decryptedData,"gkukhbjbh")

          const dataTemp = decryptedData?.filter((item) => item?.role_id !== 3);

          console.log(dataTemp, "vhvh")

          let arr = [];

          dataTemp.map((val) => {
            if (val.role_id !== 3) {
              arr.push({ name: val?.name, role: val?.role_value });
            }
          });
          setUserName(arr);
          setUserFilter(arr);
          setTempUserFilter(arr);
          setFilteredData(dataTemp);
          setLoading(true);
        }
      }
    } catch (error) {
      setLoading(true);

      console.error("Error User in:", error.message);
    }
  };

  const handleSearchChange = (e) => {
    const searchText = e.target.value;
    setSearchQuery(searchText);
    const filteredData = searchText
      ? userName.filter((row) =>
        row.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.email?.toLowerCase().includes(searchText) ||
        row.designation?.toLowerCase().includes(searchText)
      )
      : userName;
    setUserFilter(filteredData);
    setTempUserFilter(filteredData);
  };

  const handleSearchRole = (e) => {
    const searchRole = e.target.value;
    setSearchrole(searchRole);
    const Filtersearch = searchRole
      ? filterdRoles.filter((row) =>
        row.value.toLowerCase().includes(searchRole.toLowerCase())
      )
      : roleData?.filter((item) => item.id !== 3);
    setRoleFilter(Filtersearch);
  };

  // const debouncedHandleSearchChange = debounce((searchText) => {
  //   fetchData(selectedRoles, searchText);
  // }, 300);

  // useEffect(() => {
  //   debouncedHandleSearchChange(searchQuery);
  // }, [searchQuery, selectedRoles]);

  const handleChange = (name) => {
    const Selectedrole = selectedRoleCheckboxes.includes(name)
      ? selectedRoleCheckboxes.filter((item) => item !== name)
      : [...selectedRoleCheckboxes, name];
    setSelectedRoleCheckboxes(Selectedrole);
    let updatedUserFilters = [];
    if (Selectedrole.length > 0) {
      if (Selectedrole.includes(name)) {

        userName.forEach((element) => {
          Selectedrole.map((val) => {

            if (element.role === val) {
              let userF = {
                name: element.name,
                role: element.role,
              };
              updatedUserFilters.push(userF);
            }
          })
        });
      } else {
        updatedUserFilters = updatedUserFilters.filter(
          (item) => item.role !== name
        );
      }
    } else {
      updatedUserFilters = [...tempUserFilter]
    }
    setUserFilter(updatedUserFilters);
  };

  const handleUserChange = (ele) => {
    const Selectedname = selectedFilterCheckboxes.includes(ele.name)
      ? selectedFilterCheckboxes.filter((item) => item !== ele.name)
      : [...selectedFilterCheckboxes, ele.name];
    setSelectedFilterCheckboxes(Selectedname);

    let updatedRoleFilters = [...rolefilter];

    if (Selectedname.includes(ele.name)) {
      roleData?.forEach((element) => {
        if (element.value === ele.role) {
          let roleF = {
            label: `${element.label}`,
            value: `${element.value}`,
          };
          updatedRoleFilters.push(roleF);
        }
      });
    } else {
      updatedRoleFilters = updatedRoleFilters.filter(
        (item) => item.value !== ele.role
      );
    }
    setRoleFilter(updatedRoleFilters);
    //calling
    // fetchData(selectedRole,Selectedname,activeStatus)
  };

  // const handleUserChange = (ele) => {
  //   const Selectedname = selectedFilterCheckboxes.includes(ele.name)
  //     ? selectedFilterCheckboxes.filter((item) => item !== ele.name)
  //     : [...selectedFilterCheckboxes, ele.name];
  //   setSelectedFilterCheckboxes(Selectedname);

  //   let updatedRoleFilters = [...rolefilter];

  //   if (Selectedname.includes(ele.name)) {
  //     roleData?.forEach((element) => {
  //       if (element.value === ele.role) {
  //         let roleF = {
  //           label: `${element.label}`,
  //           value: `${element.value}`,
  //         };
  //         updatedRoleFilters.push(roleF);
  //       }
  //     });
  //   } else {
  //     updatedRoleFilters = updatedRoleFilters.filter(
  //       (item) => item.value !== ele.role
  //     );
  //   }
  //   setRoleFilter(updatedRoleFilters);
  // };

  const handleCancle = () => {
    handleClearFilter();
    setIsDropdownOpen(true)

  }

  const filterdsumbit = () => {
    fetchData(selectedRoleCheckboxes, selectedFilterCheckboxes);
    setopenFilterModal(false);
  };

  const pdfhandler = (url) => {
    window.open(url, "_blank");
  };

  const displayData = () => {
    if (tempLeaveSummury) {
      let subLeaveData = {};
      tempSubLeaveType?.map((doc) => {
        subLeaveData = {
          ...subLeaveData,
          [doc?.sub_leave_type_id]: doc?.sub_leave_title,
        };
      });
      let LeaveObj = [];
      Object.keys(subLeaveData)
        .sort()
        .map((itemKey, index) => {
          LeaveObj.push({
            key: index,
            leave_type: subLeaveData[itemKey],
            day_assign: tempLeaveSummury[0]?.leave_summary[itemKey],
            day_taken:
              tempLeaveSummury[0]?.leave_summary[itemKey] -
              tempLeaveSummury[0]?.remaining_leave_summary[itemKey],
            balance: tempLeaveSummury[0]?.remaining_leave_summary[itemKey],
          });
        });
      setLeaveSummaryData(LeaveObj);
    }
    setRowData(viewUserData);
    setViewModal(true);
  };

  const deletehandler = async (item) => {
    setDeleteId(item?.id);
    setopenModal(true);
  };

  const handleUserDelete = async () => {
    try {
      setLoading(false);
      const tempVal = state?.getRoleData.data?.data;
      const dataRole = tempVal?.filter((item) => item?.id !== 3);
      setRoleData(dataRole);

      const data = { userId: deleteId, }

      // Encrypt data
      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

      //Encrypt api endpoint
      const deleteEmployee = CryptoJS.SHA256("/deleteEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${deleteEmployee}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 404) {
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          toast.success("user deleted successfully !", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "success1",
          });
          setopenModal(false);
          fetchData(selectedRoleCheckboxes, selectedFilterCheckboxes);
        }
      }
    } catch (error) {
      console.error("Error User in:", error.message);
    }
  };

  const handledeleteNo = () => {
    setopenModal(false);
  };

  const btnHandler = () => {
    navigate("/addemployee");
  };

  const FilterPopup = () => {
    setopenFilterModal(true);
  };

  const closeFilterModel = () => {
    setopenFilterModal(false);
    setSearchrole("");
    setSearchQuery("");
    // setActiveStatus(true);
  };

  const handleClearFilter = () => {
    setSelectedFilterCheckboxes([]);
    setSelectedRoleCheckboxes([]);
    setUserFilter([]);
    setTempUserFilter([])
    setRoleFilter([]);
    setSearchrole("");
    setSearchQuery("");
    setActiveStatus(true);
    const selectedRoleCheckboxes = [];
    const selectedFilterCheckboxes = [];
    const activeStatusClear = true;
    fetchData(selectedRoleCheckboxes, selectedFilterCheckboxes, activeStatusClear);
    setopenFilterModal(false);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper" >
        <Card
          bodyStyle={{ height: "calc(100vh - 100px)", padding: "10px" }}
          bordered={false}
          style={{
            margin: 10,
            padding: 10,
          }}
        >
          <div className="AllEmployeeHeaderWrapper" style={{ paddingTop: "0px" }}>
            <div className="AllEmployeeHeader">
              <div className="HeaderTitle ">
                <Title
                  level={2}
                  style={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardBold",
                    fontWeight: 500,
                    marginBottom: "0px",
                  }}
                >
                  All Employee
                </Title>
                {/* <div className="iconFilterDown">
                  <FilterListIcon onClick={FilterPopup} />
                </div> */}
                <div className="iconplus">
                  <AddCircleOutlineIcon onClick={btnHandler} />
                </div>
              </div>

              <div className="btn-flex">
                <div className="AddEmployeeButton cmn_box">
                  <Button
                    size="large"
                    variant="contained"
                    htmlType="submit"
                    onClick={btnHandler}
                    style={{
                      backgroundColor: "#244DA0",
                      borderRadius: "6px",
                      color: "white",
                      fontWeight: "500",
                      borderColor: "#244DA0",
                      textTransform: "none",
                      fontFamily: "MilliardMedium"
                      // height: "44px",
                    }}
                  >
                    Add Employee
                  </Button>
                </div>
              </div>

            </div>
          </div>

          {/* Serach Bar */}
          <div className="card bg-light border-2 rounded-lg shadow-sm p-4 mb-6" >
            <div className="flex flex-wrap align-items-center gap-4" style={{ fontFamily: "MilliardBook" }}>

              <TextField
                placeholder="Search Employees..."
                value={searchQuery}
                // onChange={(e) => setSearchQuery(e.target.value)}
                onChange={handleSearchChange}
                style={{
                  width: "100%",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  sx: {
                    height: 40,
                    fontFamily: "Milliard"
                  },
                }}
              />
              {/* filter by Name
              <Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                style={{
                  // width: "full",
                  // paddingLeft: "16px",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}>

                <FormControl fullWidth>
                  <Select
                    id="name-filter"
                    multiple
                    displayEmpty
                    value={selectedFilterCheckboxes}
                    open={isDropdownOpen}
                    onOpen={() => setIsDropdownOpen(true)}
                    onClose={() => {
                      setIsDropdownOpen(false)
                      // e.stopPropagation();
                      // e.preventDefault();
                    }}
                    onChange={(e) => {
                      const next = e.target.value;
                      setSelectedFilterCheckboxes(next);
                      fetchData(selectedRoleCheckboxes, next, activeStatus)//update listing
                    }}

                    renderValue={(selected) =>
                      selected.length === 0 ? 'Name' : selected.join(', ')
                    }
                    IconComponent={() =>
                      !isDropdownOpen && selectedFilterCheckboxes.length > 0 ? (
                        <IconButton size="small" onClick={handleCancle}>
                          <CancelIcon color='error' />
                        </IconButton>
                      ) : (
                        <ArrowDropDownIcon sx={{ color: '#757575' }} />
                      )}
                    sx={{
                      height: 40,
                      width: '140px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}


                    MenuProps={{
                      // disableAutoFocusItem: true,
                      PaperProps: {
                        style: {
                          // minHeight: 200,
                          width: 250,
                        },
                      },
                      MenuListProps: {
                        // onMouseDown: (e) => e.stopPropagation(),
                        style: {
                          // minHeight: '144px',
                          maxHeight: '176px',
                          overflowY: 'auto',
                        }
                      }
                    }}

                  >

                    {userfilter?.map((ele) => (
                      <MenuItem key={ele.name} value={ele.name}>
                        <Checkbox
                          checked={selectedFilterCheckboxes.includes(ele.name)}
                        />
                        <ListItemText primary={ele.name} />
                      </MenuItem>
                    ))}
                    
                  </Select>

                </FormControl>
              </Box> */}
              {/* filter by role */}
              <Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                style={{
                  // width: "full",
                  // paddingLeft: "16px",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}>
                <FormControl fullWidth>
                  <Select
                    id="role-select"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    sx={{
                      height: 40,
                    }}
                  >
                    <MenuItem value="All">All Roles</MenuItem>
                    <MenuItem value="Employee">Employee</MenuItem>
                    <MenuItem value="Intern/Trainee">Intern/Trainee</MenuItem>
                  </Select>

                </FormControl>
              </Box>


              {/* Active and inactive select */}
              <Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                style={{
                  // width: "full",
                  // paddingLeft: "16px",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}>
                <FormControl fullWidth>
                  <Select
                    id="status-select"
                    value={activeStatus}

                    displayEmpty //ensure even false get show
                    // label='Status'
                    renderValue={(val) => (val ? 'Active' : 'Inactive')}

                    onChange={handleActiveStatusChange}
                    sx={{
                      height: 40,
                    }}
                  >
                    <MenuItem value={false}>Inactive</MenuItem>
                    <MenuItem value={true}>Active</MenuItem>

                  </Select>

                </FormControl>
              </Box>
              {/* <div className="flex items-center gap-2 "
                style={{
                  paddingTop: "16px",
                  paddingBottom: "16px",
                }}>
                <Typography style={{
                  paddingRight: "2px",
                  paddingTop: "5px",
                  paddingBottom: "16px",
                }}>
                  Inactive
                </Typography>
                <Switch checked={activeStatus} onChange={handleActiveStatusChange} />
                <Typography style={{
                  paddingRight: "5px",
                  paddingTop: "5px",
                  paddingBottom: "16px",
                }}>
                  Active
                </Typography>
              </div>*/}
            </div>
          </div>

          {/* {hasSelected ? `Selected ${checkedState.length} items` : ""} */}
          <div style={{
            // maxHeight: 'calc(100vh - 300px)', // adjust 200px based on your header/footer height
            // overflowY: 'auto',
            overflowX: 'auto', // for horizontal scroll if needed
            width: '100%',
          }} className="All_employee_table">
            {loading ? (
              <TableContainer component={Paper} className="table-container"
                style={{
                  maxHeight: 'calc(100vh - 270px)',
                  overflowY: 'auto',
                  width: '100%',
                  borderTopLeftRadius: 15,
                  borderTopRightRadius: 15,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0
                }}>
                <Table
                  sx={{
                    minWidth: 650,
                    '& th, & td': {
                      border: '1px solid #f0f0f0',
                    },
                  }}
                  aria-label="simple table"
                >
                  <TableHead
                    // displaySelectAll={true}
                    className="table_Header_color"
                    sx={{ height: "50px" }}
                  >
                    <TableRow
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#244DA0",

                      }}
                    >
                      {/* <TableCell></TableCell> */}
                      <TableCell style={{ color: "white", }}>
                        Name
                      </TableCell>

                      <TableCell style={{ color: "white", }}>
                        Employee ID
                      </TableCell>

                      <TableCell style={{ color: "white" }}>
                        Company Email
                      </TableCell>

                      <TableCell style={{ color: "white" }}>
                        Designation
                      </TableCell>

                      <TableCell style={{ color: "white" }}>
                        Joining Date
                      </TableCell>

                      <TableCell style={{ color: "white" }}>
                        Role
                      </TableCell>

                      <TableCell style={{ color: "white" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentItems?.length > 0 ? (
                      currentItems.map((row) => (
                        <TableRow
                          onClick={() => fetchLeaveSummary(row)}
                          key={row?.name}
                          sx={{

                            cursor: "pointer"
                          }}
                        >
                          {/* <div> */}
                          <TableCell style={{ padding: "5px 16px" }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {row?.profile_pic ? (
                                <img
                                  style={{
                                    height: "40px",
                                    width: "40px",
                                    borderRadius: "50%",
                                    objectFit: "fill",
                                  }}
                                  src={`${env.backend_api_endpoint}/files/${row?.profile_pic}`}
                                  alt={`${row?.profile_pic}`}
                                />
                              ) : (

                                // <AccountCircleIcon
                                //   style={{
                                //     height: "45px",
                                //     width: "45px",
                                //     borderRadius: "50%",
                                //     // color: "#244DA0",
                                //   }}
                                // /> 
                                <Tag
                                  style={{
                                    borderRadius: "60px",
                                    fontWeight: "bold",
                                    border: 0,
                                    height: "40px",
                                    width: "40px",
                                    fontSize: "18px",
                                    backgroundColor: "#c8e4fc",
                                    color: "navy",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {row?.name?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")}
                                </Tag>
                              )}
                              <span style={{ padding: "10px" }}>{row?.name}</span>
                            </div>
                          </TableCell>
                          {/* </div> */}
                          <TableCell>{row?.emp_id}</TableCell>
                          <TableCell className="company_email" style={{ color: "#6B7280" }}>{row?.company_email}</TableCell>
                          <TableCell>{row?.designation}</TableCell>
                          <TableCell>{moment(row?.joining_date).format("DD-MM-YYYY")}</TableCell>
                          <TableCell>
                            <Tag style={{ borderRadius: "20px", fontWeight: "bold" }} color="orange">{row?.role_value}</Tag>
                          </TableCell>
                          <TableCell>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                              }}
                            >
                              {/* <Tooltip title="View">
                                <VisibilityIcon
                                  onClick={() => fetchLeaveSummary(row)}
                                  style={{
                                    border: "none",
                                    color: "rgb(36,72,177)",
                                    fontSize: "19px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip> */}
                              <Tooltip title="Edit">
                                <EditIcon
                                  onClick={() =>
                                    navigate("/updateemployee", {
                                      state: row,
                                    })
                                  }
                                  style={{
                                    color: "green",
                                    border: "none",
                                    fontSize: "19px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title="Delete">
                                <DeleteIcon
                                  onClick={(e) => {
                                    e.stopPropagation(); // Stop TableRow's onClick
                                    deletehandler(row)
                                  }}
                                  style={{
                                    color: "red",
                                    border: "none",
                                    fontSize: "19px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No records found.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <span class="loader"></span>
            )}
          </div>

          <Pagination
            style={{ marginBottom: "30px" }}
            count={totalPages}
            page={currentPage}
            color="primary"
            className="pagination"
            onChange={handlePageChange}
          />

          {/* Delete Employee Model */}
          <Dialog open={openModal}>
            <DialogContent>
              <center>
                <ErrorIcon style={{ fontSize: "50px" }} />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Are you sure to delete this employee?
              </p>
            </DialogContent>
            <DialogActions
              style={{ justifyContent: "center", marginBottom: "10px" }}
            >
              <Button
                block
                size="large"
                key="submit"
                type="primary"
                onClick={handledeleteNo}
                style={{
                  backgroundColor: "#E20E0E",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#E20E0E",
                  textTransform: "none",
                  width: "120px",
                }}
              >
                No
              </Button>
              <Button
                size="large"
                block
                key="back"
                id="btndelete"
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  color: "white",
                  textTransform: "none",
                  width: "120px",
                }}
                onClick={handleUserDelete}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* view Employee Detail Model   Not Useing in web */}
          <div className="view_popup">
            <Dialog onClose={() => setViewModal(false)}>
              <DialogTitle id="dialog_title">
                {rowData?.name}
                <IconButton
                  aria-label="close"
                  onClick={() => setViewModal(false)}
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <Divider />
              <DialogContent>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Company Email:{" "}
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.company_email}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Employee Status
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.active_user === true ? "Active" : "Inactive"}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Personal Email:{" "}
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.hasOwnProperty("personal_email")
                      ? rowData?.personal_email
                      : "-"}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Date Of Birth:{" "}
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.hasOwnProperty("dob") ? rowData?.dob : "-"}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">Gender: </Typography>
                  <Typography className="typography_view">
                    {rowData?.gender ? rowData?.gender : "-"}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Phone No:{" "}
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.phone_no ? rowData?.phone_no : "-"}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">
                    Alternate No:{" "}
                  </Typography>
                  <Typography className="typography_view">
                    {rowData?.alternate_no == "" ? "-" : rowData?.alternate_no}
                  </Typography>
                </div>
                <div id="modelCol">
                  <Typography className="typography_view">Address: </Typography>
                  <Typography className="typography_view">
                    {rowData?.address ? rowData?.address : "-"}
                  </Typography>
                </div>
                {/* <Button
                  block
                  size="large"
                  key="submit"
                  variant="contained"
                  onClick={() => pdfhandler(rowData.resume)}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    fontWeight: "500",
                    borderColor: "#244DA0",
                    color: "white",
                    display:
                      rowData.hasOwnProperty("resume") &&
                      rowData.resume.length > 1
                        ? "block"
                        : "none",
                  }}
                  disabled={rowData.hasOwnProperty("resume") ? false : true}
                >
                  View Resume
                </Button> */}
                {leaveSummaryData?.length > 0 ? (
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead className="table_Header_color">
                      <TableRow>
                        <TableCell>Leave Type</TableCell>
                        <TableCell>Days Assign</TableCell>
                        <TableCell>Days Taken</TableCell>
                        <TableCell>Leave Balance</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {leaveSummaryData?.map((row) => (
                        <TableRow
                          // key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>{row.leave_type}</TableCell>
                          <TableCell>{row.day_assign}</TableCell>
                          <TableCell>{row.day_taken}</TableCell>
                          <TableCell>{row.balance}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <p>No Leaves Assigned</p>
                )}
              </DialogContent>
            </Dialog>
          </div>

          {/* Filter Model */}
          {/*  <Dialog open={openFilterModal} className="filter_model">
            <DialogTitle
              id="Leave_title"
              className="d-flex"
              style={{ justifyContent: "space-between" }}
            >
              Filters
              <div>
                <Button
                  onClick={handleClearFilter}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    borderColor: "#244DA0",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Clear All
                </Button>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <div className="filter_Dialog">
                <Box
                  sx={{
                    flexGrow: 1,
                    bgcolor: "background.paper",
                    display: "flex",
                    height: 224,
                  }}
                >
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleTChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: "divider" }}
                    className="tab_div"
                  >
                    <Tab label="Name" sx={{ textTransform: "none" }} />
                    <Tab label="Role" sx={{ textTransform: "none" }} />
                    <Tab label="Status" sx={{ textTransform: "none" }} />
                  </Tabs>
                  <div>
                    <div className="SearchInput_list">
                      <TextField
                        // className="SearchInput"
                        id="r5"
                        placeholder="Search"
                        value={value == 0 ? searchQuery : searchrole}
                        onChange={
                          value == 0 ? handleSearchChange : handleSearchRole
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon style={{ color: "lightgray" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    <TabPanel className="Tab_Panel" value={value} index={0}>
                      {/* <div className="SearchInput ">
                      <TextField
                        className="SearchInput"
                        id="r5"
                        placeholder="Search.."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon style={{ color: "lightgray" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div> */}
          {/* <div>
                        {userfilter?.map((ele) => {
                          return (
                            <li className="filter_list">
                              <Checkbox
                                checked={selectedFilterCheckboxes.includes(
                                  ele?.name
                                )}
                                onChange={() => handleUserChange(ele)}
                                name={ele?.name}
                                style={{
                                  padding: "0px",
                                  marginRight: "10px",
                                  color: "darkgray",
                                }}
                              />
                              {ele.name}
                            </li>
                          );
                        })}
                      </div>
                    </TabPanel>
                    <TabPanel className="Tab_Panel" value={value} index={1}>
                      <div>
                        {filterdRoles?.map((ele) => {
                          return (
                            <li className="filter_list">
                              <Checkbox
                                checked={selectedRoleCheckboxes.includes(
                                  ele.value
                                )}
                                onChange={() => handleChange(ele.value)}
                                name={ele.value}
                                style={{
                                  padding: "0px",
                                  marginRight: "10px",
                                  color: "darkgray",
                                }}
                              />

                              {ele.value}
                            </li>
                          );
                        })}
                      </div>
                    </TabPanel>
                    <TabPanel className='Tab_Panel' value={value} index={2}>
                      <div>
                        <li className="filter_list">
                          <Checkbox
                            checked={activeStatus === true}
                            onChange={handleStatusChange}
                            name="active"
                            style={{
                              padding: "0px",
                              marginRight: "10px",
                              color: "darkgray",
                            }}
                          />
                          Active
                        </li>
                        <li className="filter_list">
                          <Checkbox
                            checked={activeStatus === false}
                            onChange={handleStatusChange}
                            name="inactive"
                            style={{
                              padding: "0px",
                              marginRight: "10px",
                              color: "darkgray",
                            }}
                          />
                          Inactive
                        </li>
                      </div>
                    </TabPanel>
                  </div>
                </Box>
              </div>
            </DialogContent>
            <Divider />
            <DialogActions
              style={{ justifyContent: "space-around", margin: "0px" }}
            >
              <div className="button-container" onClick={closeFilterModel}>
                <Button
                  block
                  size="large"
                  // onClick={closeFilterModel}
                  style={{
                    borderRadius: "6px",
                    color: "red",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                  className="btn_hover_effect"
                >
                  Close
                </Button>
              </div>
              <div className="button-container" onClick={filterdsumbit}>
                <Button
                  size="large"
                  block
                  key="back"
                  // onClick={filterdsumbit}
                  style={{
                    borderRadius: "6px",
                    color: "#244DA0",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                  className="btn_hover_effect"
                >
                  Apply
                </Button>
              </div>
            </DialogActions>
          </Dialog>
 */}
          {/* Leave Assigned Successfully Model */}
          <Dialog
            open={showSuccess}
            onClose={() => setShowSuccess(false)}
            width={500}
          >
            <DialogContent>
              <center>
                <img
                  src={Check}
                  alt=""
                  style={{ height: "50px", width: "50px" }}
                />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Leave Assigned Successfully
              </p>
              <div
                className="customStyle"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  columnGap: "20px",
                }}
              >
                <Button
                  size="large"
                  key="back"
                  onClick={() => setShowSuccess(false)}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    textTransform: "none",
                  }}
                  fullWidth
                >
                  Ok
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </Card>
      </div >
    </LeaveStyle >
  );
};

export default Allemployee;
